function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.3492 20.5118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Lager_2",
    "data-name": "Lager 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lager_1-2",
    "data-name": "Lager 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-envelope",
    "data-name": "Icon awesome-envelope",
    d: "M26.8306,6.773a.3215.3215,0,0,1,.5186.2508V17.9474a2.5644,2.5644,0,0,1-2.5644,2.5644H2.5645A2.5644,2.5644,0,0,1,0,17.9474H0V7.0291a.3162.3162,0,0,1,.5186-.2509c1.1963.93,2.7825,2.108,8.2317,6.0679,1.1267.8221,3.0292,2.5528,4.9253,2.5422,1.9067.0158,3.846-1.7517,4.9306-2.5422C24.0533,8.8883,25.6343,7.7026,26.8306,6.773Zm-13.156,6.9015c1.2395.0211,3.0229-1.56,3.9209-2.2134,7.0881-5.1435,7.6278-5.5925,9.2625-6.8741a1.2785,1.2785,0,0,0,.4912-1.01V2.5644A2.5644,2.5644,0,0,0,24.7848,0H2.5645A2.5644,2.5644,0,0,0,0,2.5644H0V3.5836a1.286,1.286,0,0,0,.4912,1.01C2.126,5.87,2.6657,6.324,9.7538,11.4675,10.6507,12.1146,12.4372,13.6956,13.6746,13.6745Z",
    style: {
      fill: "#3a404e"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendFill);
export default __webpack_public_path__ + "static/media/send_fill.596378431973032272674de80c9e278e.svg";
export { ForwardRef as ReactComponent };